/* eslint-disable no-unused-vars */
// @flow

import * as at from '../actions/action-types';
import type { State as TopLevelState } from '../store';
import type {
  ReceiveResourceAction,
  FailToReceiveResourceAction,
  RemoveScan,
} from '../actions';
import {
  QUIK_SET_CUSTOMER,
  QUIK_CONTACT_LIST,
  QUIK_OPEN_ITEMS_LIST,
  QUIK_ORDER_DETAILS,
  QUIK_ORDER_DETAILS_CLEAR,
  QUIK_PAYMENT_DETAILS_CLEAR,
  QUIK_SHIPMENT_DETAILS_CLEAR,
  QUIK_ORDER_LIST,
  QUIK_PENDING_ORDER_LIST,
  QUIK_PAYMENT_DETAILS,
  QUIK_PAYMENT_LIST,
  QUIK_SHIPMENT_DETAILS,
  QUIK_SHIPMENT_LIST,
  QUIK_SET_ORDER_DETAILS_ITEMS,
  QUIK_SET_LOCAL_CONTACT_LIST,
  QUIK_SET_SHIPMENT_DETAILS,
} from '../actions/action-types/quik-order-history';
import type {
  QuikOrder,
  QuikPendingOrder,
  QuikShipment,
  QuikOpenItem,
  QuikPayment,
  QuikContact,
  QuikOrderDetails,
  QuikShipmentDetailsResponse,
  QuikPaymentDetails,
} from '../modules/quik-order-history';

export type State = {
  error: string,
  customerNumber: string,
  pendingOrderList: {
    data: QuikPendingOrder[],
    isLoading: boolean,
  },
  orderList: {
    data: QuikOrder[],
    isLoading: boolean,
  },
  shipmentList: {
    data: QuikShipment[],
    isLoading: boolean,
  },
  openItemsList: {
    data: QuikOpenItem[],
    isLoading: boolean,
  },
  returnList: {
    data: QuikOrder[],
    isLoading: boolean,
  },
  paymentList: {
    data: QuikPayment[],
    isLoading: boolean,
  },
  contactList: {
    data: QuikContact[],
    localData: QuikContact[],
    isLoading: boolean,
  },
  orderDetails: {
    data: QuikOrderDetails,
    isLoading: boolean,
  },
  shipmentDetails: {
    data: QuikShipmentDetailsResponse,
    isLoading: boolean,
  },
  paymentDetails: {
    data: QuikPaymentDetails,
    isLoading: boolean,
  },
};

export const initialState: State = {
  pendingOrderList: {
    data: [],
    isLoading: false,
  },
  orderList: {
    data: [],
    isLoading: false,
  },
  shipmentList: {
    data: [],
    isLoading: false,
  },
  openItemsList: {
    data: [],
    isLoading: false,
  },
  returnList: {
    data: [],
    isLoading: false,
  },
  paymentList: {
    data: [],
    isLoading: false,
  },
  contactList: {
    data: [],
    localData: [],
    isLoading: false,
  },
  orderDetails: {
    // $FlowFixMe[prop-missing]
    data: { ...null },
    isLoading: false,
  },
  shipmentDetails: {
    // $FlowFixMe[prop-missing]
    data: { ...null },
    isLoading: false,
  },
  paymentDetails: {
    // $FlowFixMe[prop-missing]
    data: { ...null },
    isLoading: false,
  },
  error: '',
  customerNumber: '',
};

const endpoints = [
  QUIK_CONTACT_LIST,
  QUIK_OPEN_ITEMS_LIST,
  QUIK_ORDER_DETAILS,
  QUIK_ORDER_LIST,
  QUIK_PENDING_ORDER_LIST,
  QUIK_PAYMENT_DETAILS,
  QUIK_PAYMENT_LIST,
  QUIK_SHIPMENT_DETAILS,
  QUIK_SHIPMENT_LIST,
];

type QuikOrderListPayload = {
  I_CUSTOMER_PO_NUMBER: string,
  I_ORDER_NUMBER: string,
  I_LANGUAGE: string,
  I_SOLD_TO_NUMBER: string,
  I_SHIP_TO_NUMBER: string,
};

export default (state: State = initialState, action: any): State => {
  const { data, method, resourceName } = action.payload || { ...null };

  if (method && !endpoints.includes(resourceName)) {
    return state;
  }

  switch (action.type) {
    case QUIK_SET_CUSTOMER:
      return {
        ...state,
        customerNumber: action.payload,
      };
    case QUIK_SET_ORDER_DETAILS_ITEMS:
      return {
        ...state,
        orderDetails: {
          ...state.orderDetails,
          data: {
            ...state.orderDetails.data,
            orderItems: action.payload,
          },
        },
      };
    case QUIK_ORDER_DETAILS_CLEAR:
      return {
        ...state,
        orderDetails: {
          // $FlowFixMe[prop-missing]
          data: { ...null },
          isLoading: false,
        },
      };

    case QUIK_PAYMENT_DETAILS_CLEAR:
      return {
        ...state,
        paymentDetails: {
          // $FlowFixMe[prop-missing]
          data: { ...null },
          isLoading: false,
        },
      };

    case QUIK_SHIPMENT_DETAILS_CLEAR:
      return {
        ...state,
        shipmentDetails: {
          // $FlowFixMe[prop-missing]
          data: { ...null },
          isLoading: false,
        },
      };

    case QUIK_SET_SHIPMENT_DETAILS:
      return {
        ...state,
        shipmentDetails: {
          ...state.shipmentDetails,
          data: {
            ...state.shipmentDetails.data,
            shipmentList: action.payload,
          },
        },
      };
    case QUIK_SET_LOCAL_CONTACT_LIST:
      return {
        ...state,
        contactList: {
          ...state.contactList,
          localData: action.payload,
        },
      };
    case at.RESOURCE_REQUEST:
      switch (resourceName) {
        case QUIK_CONTACT_LIST:
          return {
            ...state,
            contactList: {
              data: [],
              localData: [],
              isLoading: true,
            },
          };
        case QUIK_ORDER_LIST:
          return {
            ...state,
            orderList: {
              data: [],
              isLoading: true,
            },
          };
        case QUIK_ORDER_DETAILS:
          return {
            ...state,
            orderDetails: {
              // $FlowFixMe[prop-missing]
              data: { ...null },
              isLoading: true,
            },
          };
        case QUIK_SHIPMENT_LIST:
          return {
            ...state,
            shipmentList: {
              data: [],
              isLoading: true,
            },
          };
        case QUIK_SHIPMENT_DETAILS:
          return {
            ...state,
            shipmentDetails: {
              // $FlowFixMe[prop-missing]
              data: { ...null },
              isLoading: true,
            },
          };
        case QUIK_OPEN_ITEMS_LIST:
          return {
            ...state,
            openItemsList: {
              data: [],
              isLoading: true,
            },
          };
        case QUIK_PAYMENT_LIST:
          return {
            ...state,
            paymentList: {
              data: [],
              isLoading: true,
            },
          };
        case QUIK_PAYMENT_DETAILS:
          return {
            ...state,
            paymentDetails: {
              // $FlowFixMe[prop-missing]
              data: { ...null },
              isLoading: true,
            },
          };
        default:
          return state;
      }
    case at.RESOURCE_FAIL_TO_RECEIVE:
      return {
        ...state,
        pendingOrderList: {
          data: state.pendingOrderList.data,
          isLoading: false,
        },
        orderList: {
          data: state.orderList.data,
          isLoading: false,
        },
        shipmentList: {
          data: state.shipmentList.data,
          isLoading: false,
        },
        openItemsList: {
          data: state.openItemsList.data,
          isLoading: false,
        },
        returnList: {
          data: state.returnList.data,
          isLoading: false,
        },
        paymentList: {
          data: state.paymentList.data,
          isLoading: false,
        },
        orderDetails: {
          data: state.orderDetails.data,
          isLoading: false,
        },
        shipmentDetails: {
          data: state.shipmentDetails.data,
          isLoading: false,
        },
        paymentDetails: {
          data: state.paymentDetails.data,
          isLoading: false,
        },
        contactList: {
          data: state.contactList.data,
          localData: state.contactList.localData,
          isLoading: false,
        },
        error: 'api_call_failed',
      };
    case at.RESOURCE_RECEIVE:
      switch (resourceName) {
        case QUIK_CONTACT_LIST:
          return {
            ...state,
            contactList: {
              data,
              localData: data,
              isLoading: false,
            },
          };
        case QUIK_ORDER_LIST:
          return {
            ...state,
            orderList: {
              data,
              isLoading: false,
            },
          };
        case QUIK_PENDING_ORDER_LIST:
          return {
            ...state,
            pendingOrderList: {
              data,
              isLoading: false,
            },
          };
        case QUIK_ORDER_DETAILS:
          return {
            ...state,
            orderDetails: {
              data,
              isLoading: false,
            },
          };
        case QUIK_SHIPMENT_LIST:
          return {
            ...state,
            shipmentList: {
              data,
              isLoading: false,
            },
          };
        case QUIK_OPEN_ITEMS_LIST:
          return {
            ...state,
            openItemsList: {
              data,
              isLoading: false,
            },
          };
        case QUIK_PAYMENT_LIST:
          return {
            ...state,
            paymentList: {
              data,
              isLoading: false,
            },
          };
        case QUIK_SHIPMENT_DETAILS:
          return {
            ...state,
            shipmentDetails: {
              data,
              isLoading: false,
            },
          };
        case QUIK_PAYMENT_DETAILS:
          return {
            ...state,
            paymentDetails: {
              data,
              isLoading: false,
            },
          };
        default:
          return state;
      }
    default:
      return state;
  }
};
